(function ($) {

    // Initialize page and loading state
    var paged = 2;
    var loading = false;

    // Function to load posts based on different posts types and action
    function loadPosts(post_type_query, action) {
        const loadMoreBtn = $('#load-more-button');
        const containerPosts = $('#post-container');

        if (loading) return; // Prevent multiple simultaneous requests
        loading = true;
        $.ajax({
            url: MyAjax.ajaxurl,
            type: 'POST',
            data: {action, post_type_query, paged}, // Construct data object
            beforeSend: function (xhr) {
                loadMoreBtn.hide();
            },
            success: function (response) {
                loading = false;
                if (response === 'no_more_posts') {
                    loadMoreBtn.hide();
                } else {
                    containerPosts.append(response); // Append new posts
                    paged++;
                    // Show/hide load more button based on response length
                    if (count <= paged - 1) {
                        loadMoreBtn.hide();
                    } else {
                        loadMoreBtn.show();
                    }
                }
            },
        });
    }

    // Event listener for post type name
    $('.aktuelles-themen-posts .post-name').click(function (e) {
        e.preventDefault();
        if(!$(this).hasClass('active')) {
            $('.post-name').removeClass('active');
            $(this).addClass('active');
            var post_type_query = $(this).data('slug');
            $('#post-container').empty();
            paged = 1; // Reset paged value to 1
            $('#load-more-button').show(); // Show button
            loadPosts(post_type_query, 'post_type_and_load_more');
        }
    });

    // Event listener for load more button click
    $('.aktuelles-themen-posts #load-more-button').click(function (e) {
        e.preventDefault();
        var post_type_query = $('.post-name.active').data('slug');
        loadPosts(post_type_query, 'post_type_and_load_more');
    });


})(jQuery);